const vueRelatedProductsPane = new Vue({
    name: "vueRelatedProductsPane",
    el: "#related-products-pane",
    mixins: [
        relatedAccessoriesMixin,
        requestServiceMixin,
        shoppingCartServiceMixin,
        vatMixin
    ]
});